import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api, fmtDate } from "@/lib/api";
import { useSeo, PRIVATE_SEO } from "@/lib/seo";

export default function AdminAccountsPage() {
  useSeo({ title: "Accounts | LUX", ...PRIVATE_SEO });
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "accounts"],
    queryFn: async () => (await api.get("/admin/accounts")).data,
  });
  return (
    <div className="space-y-5" data-testid="admin-accounts-page">
      <header>
        <p className="adm-label">Accounts</p>
        <h1 className="mt-2 text-3xl font-semibold text-admin-text">Advertiser accounts</h1>
        <p className="mt-1 text-sm text-admin-muted">Email and phone are masked. Only Compliance can see full contact details inside a case.</p>
      </header>
      <section className="adm-card overflow-hidden">
        {isLoading ? <p className="p-5 text-sm text-admin-muted">Loading...</p> : (
          <div className="max-h-[70vh] overflow-y-auto">
            <table className="w-full text-sm">
              <thead className="sticky top-0 bg-admin-surface2 text-xs uppercase text-admin-muted">
                <tr>
                  <th className="px-4 py-2 text-left font-semibold">Email</th>
                  <th className="px-4 py-2 text-left font-semibold">Phone</th>
                  <th className="px-4 py-2 text-left font-semibold">Status</th>
                  <th className="px-4 py-2 text-left font-semibold">Profile</th>
                  <th className="px-4 py-2 text-left font-semibold">2FA</th>
                  <th className="px-4 py-2 text-left font-semibold">Created</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-admin-border">
                {data?.accounts?.map((a) => (
                  <tr key={a.id} data-testid="admin-accounts-row">
                    <td className="px-4 py-2 text-admin-text">{a.email}{a.is_demo && <span className="adm-pill ml-2 border-admin-border bg-admin-surface2 text-admin-muted">Demo</span>}</td>
                    <td className="px-4 py-2 font-mono text-xs text-admin-muted">{a.contact || "—"}</td>
                    <td className="px-4 py-2 text-admin-text">{a.status}</td>
                    <td className="px-4 py-2"><Link to={`/profile/${a.profile_slug}`} target="_blank" className="underline text-admin-text">{a.profile_slug || "—"}</Link></td>
                    <td className="px-4 py-2 text-admin-text">{a.totp_enabled ? "Enabled" : "Off"}</td>
                    <td className="px-4 py-2 text-xs text-admin-muted">{fmtDate(a.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </section>
    </div>
  );
}
